import type { CollectivesSearchRequest } from "../types";

const collectiveKeys = {
  base: ["collective"] as const,
  lists: () => [...collectiveKeys.base, "list"] as const,
  list: (params: CollectivesSearchRequest) =>
    [...collectiveKeys.lists(), params] as const,
  details: () => [...collectiveKeys.base, "detail"] as const,
  detail: (id?: string) => [...collectiveKeys.details(), id] as const,
};

export { collectiveKeys };
